interface Price {
  amount: number;
  currency_code: string;
}

export const formatPrice = (price: Price): string => {
  const amount = price.amount.toLocaleString('nb-NO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return `${amount} kr`;
};
